import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function accountList(query?: any) {
	const queryString = formatQueryString(query);

	return await clientAxios.get(`account/list${queryString}`);
}

export async function accountShow(account_id: string) {
	return await clientAxios.get(`account/${account_id}/show`);
}

export async function accountShowByMember(member_id: string) {
	return await clientAxios.get(`account/member/${member_id}/show`);
}

export async function accountPatch(account_id: string, payload: any) {
	return await clientAxios.patch(`account/${account_id}/patch`, { payload });
}

export async function accountStatus(account_id: string, status: string) {
	return await clientAxios.post(`account/${account_id}/status`, { status });
}

export async function accountDelete(account_id: string) {
	return await clientAxios.del(`account/${account_id}/delete`);
}
